/**
 * Format the provided number value to a maximum precision
 *  The return value is not cryptographically secure!
 *  @param value: number
 *  @param precision: maximum precision
 *  @return formatted number
 */
export function formatNumberWithPrecision(value: number, precision = 4): number {
  // set fixed precision and parse to float again to remove any trailing zeros
  return Number.parseFloat(value.toPrecision(precision));
}
